import { identityClient } from '@townsquare/identity-client';

/**
 * Separate file to make mocking easier in tests.
 */
export const prefetchedAuthCheckPromise = identityClient.getUserIsAuthenticated();
